/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function JournalVoucherSystemLedgerInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { details = [] } = values;

  const handleChangeField = (path, val) => setFieldValue(path, val);

  const calcRowTotal = (mv) => {
    return (
      (parseFloat(mv.month1) || 0) + (parseFloat(mv.month2) || 0) + (parseFloat(mv.month3) || 0) +
      (parseFloat(mv.month4) || 0) + (parseFloat(mv.month5) || 0) + (parseFloat(mv.month6) || 0) +
      (parseFloat(mv.month7) || 0) + (parseFloat(mv.month8) || 0) + (parseFloat(mv.month9) || 0) +
      (parseFloat(mv.month10) || 0) + (parseFloat(mv.month11) || 0) + (parseFloat(mv.month12) || 0)
    );
  };

  const handleChangeMonth = (parentPath, monthKey, val) => {
    const parent = { ...getValueByPath(values, parentPath) };
    parent[monthKey] = val;
    parent.total = calcRowTotal(parent);
    setFieldValue(parentPath, parent);
  };

  const handleChangeDetailMonth = (idx, monthKey, val) => {
    const newDetails = [...details];
    newDetails[idx][monthKey] = val;
    newDetails[idx].total = calcRowTotal(newDetails[idx]);
    setFieldValue("details", newDetails);
  };

  const getValueByPath = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };

  const addDetail = () => {
    setFieldValue("details", [
      ...details,
      {
        offsetAccount: "",
        month1: 0, month2: 0, month3: 0, month4: 0, month5: 0, month6: 0,
        month7: 0, month8: 0, month9: 0, month10: 0, month11: 0, month12: 0, total: 0,
      },
    ]);
  };

  const removeDetail = (idx) => {
    setFieldValue("details", details.filter((_, i) => i !== idx));
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px", lineHeight: "1.4" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    th: { border: "1px solid #000", padding: "4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#f9f9f9" },
    td: { border: "1px solid #000", padding: 0, height: "30px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "12px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "14px" },
    rowLabel: { display: "flex", alignItems: "baseline", gap: "5px", marginBottom: "5px" },
    stickyCol: { position: "sticky", left: 0, backgroundColor: "#fff", zIndex: 1, borderRight: "2px solid #000" },
  };

  const MonthCells = ({ parentPath, rowData, isStatic = false }) => (
    <>
      {[...Array(12)].map((_, i) => {
        const mKey = `month${i + 1}`;
        return (
          <td key={mKey} style={s.td}>
            <input
              disabled={containView}
              type="number"
              style={s.inputTableRight}
              value={rowData[mKey]}
              onChange={(e) => isStatic ? handleChangeMonth(parentPath, mKey, e.target.value) : handleChangeDetailMonth(parentPath, mKey, e.target.value)}
            />
          </td>
        );
      })}
      <td style={{ ...s.td, textAlign: "right", paddingRight: "4px", fontWeight: "bold", backgroundColor: "#eee" }}>
        {fmt(rowData.total)}
      </td>
    </>
  );

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
        <div style={{ width: "40%" }}>
          <div style={s.rowLabel}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={s.rowLabel}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "60%" }}>
          <div style={{ fontWeight: "bold", fontSize: "15px" }}>Mẫu số S05-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={{ textAlign: "center", margin: "10px 0" }}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "18px" }}>SỔ CÁI</h2>
        <div style={{ fontStyle: "italic", fontWeight: "bold", fontSize: "14px" }}>(Dùng cho hình thức Nhật ký - Chứng từ)</div>
        <div style={{ marginTop: 5 }}>
          Tài khoản: <input disabled={containView} style={{ ...s.inputDotted, width: "100px", textAlign: "center" }} value={values.accountCode} onChange={(e) => handleChangeField("accountCode", e.target.value)} />
          {" "}Năm: <input disabled={containView} style={{ ...s.inputDotted, width: "60px", textAlign: "center" }} value={values.year} onChange={(e) => handleChangeField("year", e.target.value)} />
        </div>
      </div>

      {/* OPENING BALANCE TABLE */}
      <div style={{ marginBottom: "15px" }}>
          <table style={{ borderCollapse: "collapse", fontSize: "13px" }}>
              <tr>
                  <td style={{ ...s.th, width: "100px" }} rowSpan={2}>Số dư đầu năm</td>
                  <td style={{ ...s.th, width: "80px" }}>Nợ</td>
                  <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={values.openingDebit} onChange={(e) => handleChangeField("openingDebit", e.target.value)} /></td>
              </tr>
              <tr>
                  <td style={s.th}>Có</td>
                  <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={values.openingCredit} onChange={(e) => handleChangeField("openingCredit", e.target.value)} /></td>
              </tr>
          </table>
      </div>

      {/* MAIN MATRIX TABLE */}
      <div style={{ overflowX: "auto", border: "1px solid #000" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "1200px" }}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "150px" }}>Ghi Có các TK đối ứng Nợ với TK này</th>
              {[...Array(12)].map((_, i) => (
                <th key={i} style={{ ...s.th, width: "70px" }}>Tháng {i + 1}</th>
              ))}
              <th style={{ ...s.th, width: "80px" }}>Cộng</th>
              {!containView && <th style={{ ...s.th, width: "40px" }}>#</th>}
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              {[...Array(13)].map((_, i) => (
                <th key={i} style={s.th}>{i + 1}</th>
              ))}
              {!containView && <th style={s.th}></th>}
            </tr>
          </thead>
          <tbody>
            {/* DETAILS (OFFSET ACCOUNTS) */}
            {details.map((row, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTable} placeholder="TK đối ứng..." value={row.offsetAccount} onChange={(e) => {
                    const newDetails = [...details];
                    newDetails[idx].offsetAccount = e.target.value;
                    setFieldValue("details", newDetails);
                }} /></td>
                <MonthCells rowData={row} parentPath={idx} isStatic={false} />
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeDetail(idx)}>-</button></td>}
              </tr>
            ))}
            
            {!containView && (
                <tr>
                    <td colSpan={15} style={{ padding: "5px", textAlign: "center" }}>
                        <SoftButton variant="outlined" color="dark" size="small" onClick={addDetail}>+ Thêm tài khoản đối ứng</SoftButton>
                    </td>
                </tr>
            )}

            {/* DEBIT OCCURENCE */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#fdfdfd" }}>
              <td style={{ ...s.td, paddingLeft: "5px" }}>Cộng số phát sinh Nợ</td>
              <MonthCells parentPath="debitOccurence" rowData={values.debitOccurence} isStatic={true} />
              {!containView && <td style={s.td}></td>}
            </tr>

            {/* TOTAL CREDIT OCCURENCE */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#fdfdfd" }}>
              <td style={{ ...s.td, paddingLeft: "5px" }}>Tổng số phát sinh Có</td>
              <MonthCells parentPath="creditOccurence" rowData={values.creditOccurence} isStatic={true} />
              {!containView && <td style={s.td}></td>}
            </tr>

            {/* CLOSING BALANCE DEBIT */}
            <tr style={{ fontWeight: "bold" }}>
              <td style={{ ...s.td, paddingLeft: "5px" }}>Số dư cuối tháng (Nợ)</td>
              <MonthCells parentPath="closingDebit" rowData={values.closingDebit} isStatic={true} />
              {!containView && <td style={s.td}></td>}
            </tr>

            {/* CLOSING BALANCE CREDIT */}
            <tr style={{ fontWeight: "bold" }}>
              <td style={{ ...s.td, paddingLeft: "5px" }}>Số dư cuối tháng (Có)</td>
              <MonthCells parentPath="closingCredit" rowData={values.closingCredit} isStatic={true} />
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>
      </div>

      {/* FOOTER: SIGNATURES */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "25px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Người ghi sổ</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên)</div>
          <SoftBox mt={6}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => handleChangeField("ledgerClerk", e.target.value)} /></SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Kế toán trưởng</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên)</div>
          <SoftBox mt={6}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => handleChangeField("chiefAccountant", e.target.value)} /></SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "13px", marginBottom: "3px" }}>
            Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} />
          </div>
          <div style={{ fontWeight: "bold" }}>Người đại diện theo pháp luật</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Ký, họ tên, đóng dấu)</div>
          <SoftBox mt={6}><input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => handleChangeField("legalRepresentative", e.target.value)} /></SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}
